import StarterKit from '@tiptap/starter-kit';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import CharacterCount from '@tiptap/extension-character-count';
import Superscript from '@tiptap/extension-superscript';
import { Selection } from '@tiptap/extensions';
import { InlineMath, BlockMath } from './MathExtensions';
import { TableFocus } from './TableFocus';
import {
    CustomParagraph,
    CustomHeading,
    CustomImage,
    CustomTable,
    CustomBulletList,
    CustomOrderedList,
    CustomCodeBlock,
} from './CustomNodes';
import { all, createLowlight } from 'lowlight';

const lowlight = createLowlight(all);

/**
 * Tiptap 编辑器扩展配置
 * 包含了编辑器所需的所有功能扩展
 */
export const extensions = [
    StarterKit.configure({
        paragraph: false,
        heading: false,
        bulletList: false,
        orderedList: false,
    }),
    CustomParagraph,
    CustomHeading,
    CustomTable.configure({
        resizable: true,
    }),
    TableRow,
    TableHeader,
    TableCell,
    // 光标在表格内时给表格加 .table-focused（用装饰实现，避免直接改 DOM 被 ProseMirror 重绘）
    TableFocus,
    CustomImage,
    CustomBulletList,
    CustomOrderedList,
    InlineMath,
    BlockMath,
    // 上标扩展
    Superscript,

    CustomCodeBlock.configure({
        lowlight,
    }),

    // Selection 扩展（用于在编辑器失去焦点时保持选中状态的样式）
    Selection.configure({
        className: 'selection',
    }),

    // 字数统计扩展
    CharacterCount.configure({
        count: (text) => {
            // 移除空格和换行符后计算字数
            return text.replace(/\s+/g, '').length;
        },
    }),
];
